import { useColorScheme } from '@mui/joy';
import { ReactNode, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SelectionCountProvider } from 'core/states';
import { ModeType } from 'theme/enums';

export const IframePageLayout = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const { setMode } = useColorScheme();

  const colorMode = searchParams.get('colorMode') || ModeType.LIGHT;

  useEffect(() => {
    setMode(colorMode as ModeType);
  }, [colorMode, setMode]);

  return <SelectionCountProvider>{children}</SelectionCountProvider>;
};
